<!-- <template>
    <div class="tinymce-editor">
        <editor v-model="myValue" @onInit="lodingFinish" :init="init" :disabled="disabled" @onClick="onClick">
        </editor>
    </div>
</template>
<script>
import tinymce from "tinymce/tinymce";
import Editor from "@tinymce/tinymce-vue";
import { uploadFile } from '@/assets/js/oss';
import "tinymce/themes/silver";
import "tinymce/icons/default";
// 编辑器插件plugins
// 更多插件参考：https://www.tiny.cloud/docs/plugins/
import "tinymce/plugins/image"; // 插入上传图片插件
//import "tinymce/plugins/media"; // 插入视频插件
import "tinymce/plugins/table"; // 插入表格插件
import "tinymce/plugins/lists"; // 列表插件
import "tinymce/plugins/paste"//
import "tinymce/plugins/autoresize"; //自适应大小
import "tinymce/plugins/wordcount"; // 字数统计插件
import "tinymce/plugins/fullscreen"; //全屏
import "tinymce/icons/default/icons";

export default {
    components: {
        Editor
    },
    props: {
        value: {
            type: String,
            default: ""
        },
        // 基本路径，默认为空根目录，如果你的项目发布后的地址为目录形式，
        // 即abc.com/tinymce，baseUrl需要配置成tinymce，不然发布后资源会找不到
        baseUrl: {
            type: String,
            default: ""
        },
         height: {
            type: Number,
            default: 200
        },
        disabled: {
            type: Boolean,
            default: false
        },
        plugins: {
            type: [String, Array],
            default: "lists image table wordcount fullscreen paste"
        },
        toolbar: {
            type: [String, Array],
            default:
                "tiny_mce_wiris_formulaEditorChemistry undo redo fullscreen |  formatselect | bold underline strikethrough subscript italic forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | lists image table | removeformat"
        }
    },
    data() {
        return {
            init: {
                selector: "tox-editor-container",
                language_url: `${this.baseUrl}/tinymce/langs/zh_CN.js`,
                language: "zh_CN",
                skin_url: `${this.baseUrl}/tinymce/skins/ui/oxide`,
                setup: (editor) => {
                editor.ui.registry.addButton('insert-image', {
                    text: 'Insert image',
                    onAction: () => {
                    // 这里处理点击事件
                    console.log('插入图片按钮被点击了！');
                    // 执行插入图片逻辑
                    },
                })
                },
                content_css: `${
                    this.baseUrl
                }/tinymce/skins/content/default/content.css`,
                // skin_url: `${this.baseUrl}/tinymce/skins/ui/oxide-dark`, // 暗色系
                // content_css: `${this.baseUrl}/tinymce/skins/content/dark/content.css`, // 暗色系
                height: `${this.height}`,
                plugins: this.plugins,
                // paste_auto_cleanup_on_paste : true,
                paste_remove_styles: true,
                paste_remove_styles_if_webkit: true,
                // paste_strip_class_attributes: true,
                external_plugins: {
                    tiny_mce_wiris:
                        "https://www.wiris.net/demo/plugins/tiny_mce/plugin.js"
                },
                toolbar: this.toolbar,
                branding: false, // 去水印
                menubar: false, // 隐藏最上方menu
                statusbar: false, // 隐藏编辑器底部的状态栏
                // 此处为图片上传处理函数
                images_upload_handler: (blobInfo, success, failure) => {
                    uploadFile(blobInfo.blob()).then(res => {
                        if (res) {
                            success(this.$severUrl(res.previewUrl));
                            this.$msg({
                                message: "上传成功",
                                type: "success",
                            });
                        } else {
                            this.$msg({
                                message: "上传失败",
                                type: "error",
                            });
                            failure("");
                        }
                    });
                }
            },
            myValue: this.value
        };
    },
    mounted() {
        tinymce.init({
        });
    },
    methods: {
        // 添加相关的事件
        onClick(e) {
            this.$emit("onClick", e, tinymce);
        },
        // 可以添加一些自己的自定义事件，如清空内容
        clear() {
            this.myValue = "";
        },
        /**加载完成 */
        lodingFinish(){
            this.$emit('loading_finish');
        }
    },
    watch: {
        value(newValue) {
            this.myValue = newValue;
        },
        myValue(newValue) {
            this.$emit("input", newValue);
        }
    }
};
</script>
<style lang="less" scoped>
/deep/.tox-dialog{
    z-index: 999999 !important;
}
/deep/.tox-dialog-wrap{
    z-index: 999999 !important;
}
/deep/.tox-tinymce-aux{
    z-index: 999999 !important;
}
/deep/.tox-tinymce{
    height: 10rem !important;
}
/deep/.tox-fullscreen{
  height: 100vh !important;
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
}
</style> -->
<template>
    <div class="tinymce-editor">
      <editor
        ref="editor"
        v-model="myValue"
        :init="init"
        :disabled="disabled"
        @onInit="lodingFinish"
        @onClick="onClick"
        @onBlur="onblur"
      >
      </editor>
    </div>
  </template>
  <script>
  import tinymce from "tinymce/tinymce";
  import Editor from "@tinymce/tinymce-vue";
  import { uploadFile } from '@/assets/js/oss';
  import "tinymce/themes/silver";
  import "tinymce/icons/default";
  // 编辑器插件plugins
  // 更多插件参考：https://www.tiny.cloud/docs/plugins/
  import "tinymce/plugins/image"; // 插入上传图片插件
  //import "tinymce/plugins/media"; // 插入视频插件
  import "tinymce/plugins/table"; // 插入表格插件
  import "tinymce/plugins/lists"; // 列表插件
  // import "tinymce/plugins/wordcount"; // 字数统计插件
  import "tinymce/plugins/fullscreen"; //全屏
  import "tinymce/plugins/autoresize"; //自适应大小
  import "tinymce/plugins/paste";
  import "tinymce/icons/default/icons";
  //import "tinymce/plugins/tiny_mce_wiris"; //公式
  
  export default {
    components: {
      Editor,
    },
    props: {
      value: {
        type: String,
        default: "",
      },
      // 基本路径，默认为空根目录，如果你的项目发布后的地址为目录形式，
      // 即abc.com/tinymce，baseUrl需要配置成tinymce，不然发布后资源会找不到
      baseUrl: {
        type: String,
        default: "",
      },
      height: {
        type: Number,
        default: 50,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      // toolbar_persist:{
      //   type: Boolean,
      //   default: true
      // },
      plugins: {
        type: [String, Array],
        default: "lists image table fullscreen autoresize paste",
        //default: "lists image table wordcount fullscreen tiny_mce_wiris"
      },
      toolbar: {
        type: [String, Array],
        default:
          "tiny_mce_wiris_formulaEditor undo redo |  lists image table | bold underline strikethrough subscript italic | alignleft aligncenter alignright alignjustify  | removeformat fullscreen",
      },
    },
    data() {
      return {
        init: {
          selector: "tox-editor-container",
          //  inline: true,
          setup: function (editor) {
            editor.on("focus", function (arg) {
              arg.target.container.querySelector('.tox-editor-header').style.display="block"
            });
            editor.on("blur", function (e) {
              e.target.container.querySelector('.tox-editor-header').style.display="none"
            });
          },
          language_url: `${this.baseUrl}/tinymce/langs/zh_CN.js`,
          language: "zh_CN",
          skin_url: `${this.baseUrl}/tinymce/skins/ui/oxide`,
          content_css: `${this.baseUrl}/tinymce/skins/content/default/content.css`,
          // skin_url: `${this.baseUrl}/tinymce/skins/ui/oxide-dark`, // 暗色系
          // content_css: `${this.baseUrl}/tinymce/skins/content/dark/content.css`, // 暗色系
          height: `${this.height}`,
          plugins: this.plugins,
          external_plugins: {
            // tiny_mce_wiris:
            //   "https://www.wiris.net/demo/plugins/tiny_mce/plugin.js",
            'kityformula-editor': '/tinymce/plugins/kityformula-editor/plugin.min.js'
          },
          toolbar: this.toolbar,
           content_style:'body{line-height:0;overflow-y: auto !important} p{line-height:1 }',
          branding: false, // 去水印
          menubar: false, // 隐藏最上方menu
          // statusbar: false, // 隐藏编辑器底部的状态栏
          resize: true,
          elementpath: false,
          relative_urls: false,
          remove_script_host: false,
          paste_as_text: true,
          // 此处为图片上传处理函数
          images_upload_handler: (blobInfo, success, failure) => {
            uploadFile(blobInfo.blob()).then(res => {
                        if (res) {
                            success(this.$severUrl(res.previewUrl));
                            this.$msg({
                                message: "上传成功",
                                type: "success",
                            });
                        } else {
                            this.$msg({
                                message: "上传失败",
                                type: "error",
                            });
                            failure("");
                        }
                    });
          },
        },
        myValue: this.value,
      };
    },
    created() {},
    mounted() {
      this.getStyle()
      
    },
    methods: {
      // 添加相关的事件
      onClick(e) {
        this.$emit("onClick", e, tinymce);
      },
      onblur(e){
        this.$emit("onblur", e, tinymce);
      },
       /**加载完成 */
       lodingFinish(){
            this.$emit('loading_finish');
        },
      // 可以添加一些自己的自定义事件，如清空内容
      clear() {
        this.myValue = "";
      },
      getStyle(){
        //  document.querySelector(".tox-dropzone  input").addEventListener("change",function(e){
        //    console.log(e);
        //  })
      },
    },
    watch: {
      value(newValue) {
        this.myValue = newValue;
      },
      myValue(newValue) {
        this.$emit("input", newValue);
      },
    },
  };
  </script>
  <style scoped lang="less">
  /deep/.tox-toolbar__group:nth-child(1) {
    .tox-tbtn:nth-child(1) {
      span {
        display: none;
      }
    }
    
    .tox-tbtn:nth-child(1)::before {
      content: "∑";
      font-size: 16px;
      font-weight: 600;
      position: absolute;
      top: 5px;
    }
  }
  
  /deep/.tox-editor-header{
    display: none;
  }
  /deep/.tox-toolbar__primary {
    background-color: #f4f7ff !important;
  }
  /deep/.tox-tinymce {
    border-radius: 6px !important;
  }
  /deep/.tox-tinymce {
    //height: 120px !important;
  }
  /deep/.tox-statusbar {
    border-top: unset !important;
    height: 0 !important;
  }
  .box{
    width: 100px;
    height: 100px;
    background-color: #f0f6ff;
    img{
      width: 44px;
      height: 44px;
    }
  }
  
  </style>